import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Button from '@/components/common/Button';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4 text-center dark:bg-gray-900">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-9xl font-bold text-primary-500 dark:text-primary-400">404</h1>
        <h2 className="mb-4 text-3xl font-bold text-gray-900 dark:text-white">
          {t('error.pageNotFound')}
        </h2>
        <p className="mb-8 max-w-md text-lg text-gray-600 dark:text-gray-300">
          {t('error.pageNotFoundDescription')}
        </p>
        <div className="space-x-4">
          <Button
            as={Link}
            to="/"
            variant="primary"
          >
            {t('error.goToHome')}
          </Button>
          <Button
            as={Link}
            to="/dashboard"
            variant="outline"
          >
            {t('error.goToDashboard')}
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;